import React from "react";

function DocumentationPage() {
  return <div>Documentation</div>;
}

export default DocumentationPage;
